import { Component, OnInit,Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';

@Component({
  selector: 'app-opd-docs-status',
  templateUrl: './opd-docs-status.component.html',
  styleUrls: ['./opd-docs-status.component.css']
})
export class OpdDocsStatusComponent implements OnInit {
  showTextBox:boolean=false;loading:boolean=false;
  OpdDocsForm: FormGroup;submitted:boolean=false;
  dialogData:any;
  constructor(public dialogRef: MatDialogRef<OpdDocsStatusComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog,private formBuilder: FormBuilder,private sharedapi:SharedService, private leadapi:LeadsService) {
    
    console.log(data);
    this.dialogData=data;
    console.log(this.dialogData.data.approved_status);
   
    this.OpdDocsForm = this.formBuilder.group({ 
      'doc_approved_status' : [null, Validators.required],
      'comments' : [null],
      
    });

    this.patchData();


   }

   patchData(){
    this.OpdDocsForm.patchValue({
      'doc_approved_status':this.dialogData.data.approved_status,  
      'comments':this.dialogData.data.comments,  
    })
    this.assigedAction(this.dialogData.data.approved_status)
   }

   get f() { return this.OpdDocsForm.controls; }

  ngOnInit(): void {
  }

  CloseModal(): void {
    this.dialogRef.close();
  } 

  assigedAction(event){
    console.log(event);
    if(event!=2){
      this.showTextBox=false;
    }else{
      this.showTextBox=true;
    }
  }

  updateData(){
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.OpdDocsForm.invalid) {
        this.loading = false;
        return;
    }

    this.leadapi.updateOpdDocsStatus(this.dialogData.data.id,this.OpdDocsForm.value)
        .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast(data.msg);
                setTimeout(() => {
                  this.dialogRef.close({event:'success'});
                }, 2000);
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
      }, error => 
        {
            this.sharedapi.checkError(error);
        });
  }

}
